// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  
  
  //apiURL    : 'https://directoriolalaguna.espaciourbano.cl/api',
  //apiURL    : 'http://localhost:8017/api',
  apiURL    : 'https://directoriolalaguna.espaciourbano.cl/api/',
  edificio  : 166,
  totem     : 546,
  canal     : 2,
  idioma    : 'Esp',
  timereload : 45,
  tiendaimagen : false,
  idEst : [7262, 7097, 7264], /* IDs de estacionamientos */
  colorEst : ['Naranja', 'Verde', 'Rosa'], /* colores estacionamientos*/
  listaTotems : [565,	564,	563,	562,	561,	560,	559,	558,	557,	556,	555,	554,	553,	552,	551,	550,	549,	548,	547,	546],
  
  codCine: '0', /* id de Cine */
  patioDeComida: 0, /* id patio de comida, en caso de no haber usar 0 */
  zonaGourmet: 0, /* id zona gourmet, en caso de no haber usar 0 */
  restaurantes: [0],

  
  //socketUrl: 'https://directoriolalaguna.espaciourbano.cl',
  //socketPort: '14400’',  /* segun disponibilidad */

  //socketUrl: 'http://localhost',
  //socketPort: '8017',  /* segun disponibilidad */

  socketUrl: 'https://dev-eu-lalaguna.mzzo.com',
  socketPort: '8051',

  orientacionHor : [132,0], /* [Norte, Sur] */
  orientacionVer : [0, 0], /* [Oeste, Este] */
  tipoTransporte : {pie: 80, alternativo: 81},

  timeoutIdle : 45 /* cierre de sesion, en segundos */
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
